import { render, staticRenderFns } from "./homeSampleCollection.vue?vue&type=template&id=0854e6f4&scoped=true"
import script from "./homeSampleCollection.vue?vue&type=script&lang=js"
export * from "./homeSampleCollection.vue?vue&type=script&lang=js"
import style0 from "./homeSampleCollection.vue?vue&type=style&index=0&id=0854e6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854e6f4",
  null
  
)

export default component.exports